// extracted by mini-css-extract-plugin
export default {"infoBloc":"InfoBloc_infoBloc__gA51E","largeInfoBloc":"InfoBloc_largeInfoBloc__4gXDC"};